import type { ClanWarsSummary, UserStatsInClanWars } from '$lib/types/clanWars';
import { writable, type Writable } from 'svelte/store';

export const clanWarsSummary: Writable<ClanWarsSummary> = writable({
	totalRewardPool: 0,
	clanStats: []
});

export const loadingClanWarsSummary: Writable<boolean> = writable(true);

export const userStatsInClanWars: Writable<UserStatsInClanWars> = writable({
	clanId: null
});

export const loadingUserStatsInClanWars: Writable<boolean> = writable(false);
